import { styled } from 'common/src/designSystem/components/stitches';

export const FullPageContent = styled('div', {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    margin: '0 $3'
});
